import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
//import { ApiResponse } from '../../models/apiResponse';
//import { Observable } from 'rxjs/Observable';

/*
  Generated class for the ApiProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class ApiProvider {

   //url: string = "https://cors-anywhere.herokuapp.com/https://tms.furlong.com.ar/testing/restApi/";

  url: string = "https://cors-anywhere.herokuapp.com/https://tms.furlong.com.ar/restApi/"

  constructor(public http: HttpClient) {
  }

  get(endpoint: string, params?: HttpParams, reqOpts?: any) {
    if (!reqOpts) {
      reqOpts = {
        params: new HttpParams()
      };
    }

    if (params) {
      reqOpts.params = new HttpParams();
      for (let k in params) {
        reqOpts.params = reqOpts.params.set(k, params[k]);
      }
    }

    reqOpts = this.updReqOpts(reqOpts);

    return this.http.get(this.url + endpoint, reqOpts);
  }


  post(endpoint: string, body: any, reqOpts?: any) {
    reqOpts = this.updReqOpts(reqOpts);
    return this.http.post(this.url + endpoint, body, reqOpts);
  }

  put(endpoint: string, body: any, reqOpts?: any) {
    reqOpts = this.updReqOpts(reqOpts);
    return this.http.put(this.url + endpoint, body, reqOpts);
  }

  delete(endpoint: string, reqOpts?: any) {
    reqOpts = this.updReqOpts(reqOpts);
    return this.http.delete(this.url + endpoint, reqOpts);
  }

  patch(endpoint: string, body: any, reqOpts?: any) {
    reqOpts = this.updReqOpts(reqOpts);
    return this.http.patch(this.url + endpoint, body, reqOpts);
  }

  private updReqOpts(reqOpts?: any) {

    if (!reqOpts) reqOpts = {};

    if (!reqOpts.responseType) reqOpts.responseType = "json";
    if (!reqOpts.headers) reqOpts.headers = new HttpHeaders();
    if (!reqOpts.headers.has("Content-Type")) reqOpts.headers = reqOpts.headers.set("Content-Type", "application/json");

    return reqOpts;
  }

}



// WEBPACK FOOTER //
// ./src/providers/api/api.ts